<app-toolbar></app-toolbar>
<app-modal-popup></app-modal-popup>
<div class="wrapper">
  <app-sidebar></app-sidebar>
  <div class="content-primary">
    <div class="row">
      <div class="col-12 mb30">
        <span class="main-title">{{ 'GENERAL.WELCOME' | translate }} {{userInSession}}</span>
      </div>
      <div class="col">
        <div class="iconos-comunidad">
          <a routerLinkActive="active" [routerLink]="['/bill-collection']">
            <div class="mb5" [ngClass]="{'txt-secondary' : '/bill-collection' === urlActive}"><i
                class="fal fa-file-alt"></i></div>
            <div class="div-text"><span [ngClass]="{'txt-secondary' : '/bill-collection' === urlActive}"
                class="center text-menu">{{
                'GENERAL.COLLECTION_NOTE' | translate }}</span></div>
          </a>
        </div>
      </div>
      <div class="col">
        <div class="iconos-comunidad">
          <a routerLinkActive="active" [routerLink]="['/common-expense']">
            <div class="mb5" [ngClass]="{'txt-secondary' : '/common-expense' === urlActive}"><i
                class="fal fa-chart-bar"></i></div>
            <div class="div-text"><span [ngClass]="{'txt-secondary' : '/common-expense' === urlActive}"
                class="center text-menu">{{
                'REPORTS.COMMON_EXPENSE.GENERAL.SINGULAR' | translate }}</span></div>
          </a>
        </div>
      </div>
      <div class="col">
        <div class="iconos-comunidad">
          <a routerLinkActive="active" [routerLink]="['/debts']">
            <div class="mb5" [ngClass]="{'txt-secondary' : '/debts' === urlActive}"><i
                class="fal fa-hand-holding-usd"></i></div>
            <div class="div-text"><span [ngClass]="{'txt-secondary' : '/debts' === urlActive}" class="center text-menu">{{
                'GENERAL.COMMUNITY' | translate }}</span></div>
          </a>
        </div>
      </div>
      <div class="col">
        <div class="iconos-comunidad">
          <a routerLinkActive="active" [routerLink]="['/advertisement']">
            <div class="mb5" [ngClass]="{'txt-secondary' : '/advertisement' === urlActive}"><i
                class="fal fa-comments-alt"></i></div>
            <div class="div-text"><span [ngClass]="{'txt-secondary' : '/advertisement' === urlActive}"
                class="center text-menu">{{
                'GENERAL.ADVERTISEMENTS' | translate }}</span></div>
          </a>
        </div>
      </div>
      <div class="col">
        <div class="iconos-comunidad">
          <a routerLinkActive="active" [routerLink]="['/document-library']">
            <div class="mb5" [ngClass]="{'txt-secondary' : '/document-library' === urlActive}"><i
                class="fal fa-folder-open"></i></div>
            <div class="div-text"><span [ngClass]="{'txt-secondary' : '/document-library' === urlActive}"
                class="center text-menu">{{
                'DOCUMENT_LIBRARY.HOME.TITLE' | translate }}</span></div>
          </a>
        </div>
      </div>
      <div class="col-12 mt10">
        <div class="border-bottom"></div>
      </div>
    </div>
    <div class="col-12 mt5">
      <app-alert></app-alert>
    </div>
    <div class="tab-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/layout/layout-dashboard/layout-dashboard.component.html